import { render, staticRenderFns } from "./foodExpenseSchool.vue?vue&type=template&id=da69cd6c&scoped=true&"
import script from "./foodExpenseSchool.vue?vue&type=script&lang=js&"
export * from "./foodExpenseSchool.vue?vue&type=script&lang=js&"
import style0 from "./foodExpenseSchool.vue?vue&type=style&index=0&id=da69cd6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da69cd6c",
  null
  
)

export default component.exports